import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from "@angular/core";
import {FormControl} from "@angular/forms";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";
import {IAutoSchedulerDTO, InvestCashSetting} from "@irb/irb-editors/rebalance/irb-rebalance.model";
import {CalltoactionService} from "@irb-common/components/calltoaction/calltoaction.service";
import {
  ComAutomatedRebalancingGridLayoutService
} from "@irb/irb-editors/editor-portfolio/com-automated-rebalancing/com-automated-rebalancing.grid-layout.service";
import {IrbCreateRebalanceService, IRebalanceTypeItem} from "@irb/irb-create-rebalance/irb-create-rebalance.service";
import {IDropdownItem} from "@irb-common/models/dropdown.model";
import {IrbEditorsEvents} from "@irb/irb-editors/irb-editors.events";
import {UtilityService} from "@irb-common/services/utility.service";
import {AppService} from "@irb/app.service";
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {IrbRebalanceEvents} from "@irb/irb-rebalance/irb-rebalance.events";
import {IrbModelsEvents} from "@irb/irb-models/irb-models.events";
import {IModelDetail} from "@irb/irb-editors/irb-editors.model";
import {faChevronRight} from "@fortawesome/free-solid-svg-icons";
import {IMultiplePortfolioEditRequest} from "@irb/irb-clients/irb-clients.model";

interface AutoRebalanceDetails {
  isAutoRebalEnabled: boolean,
  autoRebalType: string,
  autoRebalRequestedBy: string,
  autoRebalStartDate: any,
  autoScheduler: IAutoSchedulerDTO
}
@Component({ standalone: false,
  selector: 'irb-com-automated-rebalancing',
  templateUrl: './com-automated-rebalancing.component.html',
  styleUrls: ['./com-automated-rebalancing.component.scss', '../../editor-sidebar/editor-sidebar.component.scss']
})
export class ComAutomatedRebalancingComponent implements OnInit {
  @ViewChild('IrbSelectedRebalanceTypeDropdown') selectReference: DropdownFilterComponent;
  @ViewChild("IrbSelectedEndOptionsDropdown") selectEndDateTypeReference: DropdownFilterComponent;
  @ViewChild("IrbendDeveryMonthListDropdown") selecteveryMonthListReference: DropdownFilterComponent;
  @ViewChild("IrbendDeveryMonthWeekDayListDropdown") selecteveryMonthWeekDayListReference: DropdownFilterComponent;
  @Output() change = new EventEmitter<any>();
  @Input()   data: any = {};
  @Input() selectedPortfolios: IMultiplePortfolioEditRequest;
  @Input() multipleporfolios: boolean = false;
  @Input() isTLHSetInGlobal: boolean = false;
  @Input() selectedModel: IModelDetail = {} as IModelDetail;
  multiPortfolioAllowedLimit: number = 999;
  selectedPortfolioCount: number

  originalDataFromServer: any = {};
  gridData: Array<any> = [];
  grid: any;
  gridOptions: any;
  autoRebalanceDetails: AutoRebalanceDetails = {} as AutoRebalanceDetails;

  enableAutomation: number = 0;
  automationEnabledDate: string = '';
  automationEndDate: string = '';
  rebalanceTypeLists: any[] = [];
  selectedRebalanceType: any = new FormControl('');
  automationStartDateControl: any = new FormControl('');
  //selectedEndOptions: any = new FormControl('');
  //automationStartDateMin: string = new Date().toLocaleString('en-US', {month:"2-digit",day:"2-digit", year:"numeric"});
  isUiTest: boolean;
  selectedEveryMonthListOptions: any = new FormControl('');
  selectedEveryMonthWeekDayListOptions: any = new FormControl('');
  endOfMonthWarning: string = "";
  toolTipStartDate: string = '';
  toolTipEndDate: string = '';
  automationStartDateValidation: any;
  endDateMinValidation: any;
  holidayDateList: any;
  completedRunTime = 0;
  schedulerEndByDate: any = new FormControl(new Date().toLocaleString('en-US', {month:"2-digit",day:"2-digit", year:"numeric"}));
  userDetails: any;
  tomorrowDate: any;
  afterTomorrowDate: any;
  isValidDateNumber: boolean = true;
  isValidNumberOfOccurrences: boolean = true;
  endAfterNTimesReady: boolean = true;
  rebalanceFrequencyValid: boolean = true;
  historyGridDomLayout: string = 'normal';
  historyGridHeight = '100%';
  monthlySchedulerOption = '0';
  autoRebalNextRunDate = '';
  isShowHistory = true;
  isActBlockAutoSchd: boolean;
  isActCashUpfront: boolean;
  isMultiPortfolioAllowedLimitExceeded: boolean;
  cashUpFrontDisabledMessage: string = '';
  cashUpFrontEnabledMessage: string = '';
  userReadOnlyDisabledMessage: string = '';
  multiPortfolioAllowedLimitMessage: string = '';
  automatedRebalanceDisabledMessage: string = '';
  showDisabledTextMessage: boolean;
  showDisabledTextMessageWhenAutoRebEnabled: boolean;
  isTlhWsaEnabled: boolean;
  specificDayObj: IDropdownItem ={
    value: "a specific date",
    name: "a specific date",
  };
  everyMonthList: Array<IDropdownItem> = [
    {
      value: "the first",
      name: "First",
    },
    {
      value: "the 2nd",
      name: "Second",
    },
    {
      value: "the 3rd",
      name: "Third",
    },
    {
      value: "the 4th",
      name: "Fourth",
    },
    {
      value: "the last",
      name: "Last",
    },
  ];
  evryMonthWeekDayList: Array<IDropdownItem> = [
    {
      value: "Mon",
      name: "Monday",
    },
    {
      value: "Tue",
      name: "Tuesday",
    },
    {
      value: "Wed",
      name: "Wednesday",
    },
    {
      value: "Thu",
      name: "Thursday",
    },
    {
      value: "Fri",
      name: "Friday",
    }
  ];
  analysisType: Map <string,string> = new Map([
    ['FULL_REBALANCE', 'Full rebalance'],
    ['GEN_CASH_ONLY', 'Generate cash only'],
    ['INVEST_CASH_ONLY', 'Invest cash only'],
    ['GEN_AND_INVEST_CASH', 'Generate / invest cash'],
    ['SINGLE_SECURITY_ADJ', 'Adjust securities'],
    ['TAX_LOSS_HARVESTING', 'Tax Loss Harvest'],
    ['SECURITY_REPLACE', 'Replace securities'],
    ['MANUAL_ADJ', 'Manual adjustment'],
    ['COVERED_CALL', 'Covered call']
  ]);
  frameworkComponents: any;
  isUserAutoRebalanceEnabled = true;
  ENABLE_INVCASH_AUTO: boolean = false;
  investCashSetting: string = InvestCashSetting.Securities;

  constructor(
  private ctas: CalltoactionService,
  private gls: ComAutomatedRebalancingGridLayoutService,
  private crbservice: IrbCreateRebalanceService,
  private us: UtilityService,
  private as: AppService,
  private cdr: ChangeDetectorRef,
  private ies: IrbEditorsService
  ) {
  }

  ngOnInit(): void {
    this.selectedPortfolioCount = this.selectedPortfolios?.portfolioCount;
    this.originalDataFromServer = JSON.parse(JSON.stringify(this.data));
    this.isShowHistory = this.as.getFromSession("ShowAutoRebalanceHistory") || false;
    this.frameworkComponents = this.gls.getFrameworkComponents();
    this.gridOptions = {
      rowModelType: 'serverSide',
      columnDefs: this.gls.getColumnDefs(this),
      floatingFilter: false,
      overlayNoRowsTemplate: "There is no automated rebalance history available.",
      context: {componentParent: this},
    };
    this.userDetails = this.as.getItem("IRB_APP_CONFIG");
    this.isUserAutoRebalanceEnabled = this.userDetails?.isAutomationEnabled && this.userDetails.isAdmin;
    this.isTlhWsaEnabled = this.userDetails?.isTlhWsaEnabled;
    const ENABLE_TLH_FR = this.userDetails?.featureFlags.ENABLE_TLH_FR || false;
    this.ENABLE_INVCASH_AUTO = this.userDetails?.featureFlags?.ENABLE_INVCASH_AUTO === true;
    if (this.userDetails?.multiPortfolioAllowedLimit) {
      this.multiPortfolioAllowedLimit = this.userDetails?.multiPortfolioAllowedLimit;
    }

    this.isMultiPortfolioAllowedLimitExceeded = (this.multipleporfolios && this.selectedPortfolioCount > this.multiPortfolioAllowedLimit);
    this.cashUpFrontDisabledMessage = 'Portfolio contains account(s) with Cash Up Front or Settled Cash Up Front restriction and cannot be enabled for automated rebalancing.';
    this.cashUpFrontEnabledMessage = 'Portfolio contains account(s) with Cash Up Front or Settled Cash Up Front restriction and cannot be automatically rebalanced. Please disable automated rebalancing or remove account(s) with Cash Up Front restriction from assigned accounts to allow automated rebalancing.';
    this.userReadOnlyDisabledMessage = 'Automated Rebalancing settings can only be modified by users with the Access iRebal Automation security function.';
    this.multiPortfolioAllowedLimitMessage = 'Automated Rebalancing cannot be edited for more than ' +this.multiPortfolioAllowedLimit+ ' portfolios. Please reduce the number of selected portfolios.';
    if (this.multipleporfolios) {
      this.isActCashUpfront = this.selectedPortfolios?.actBlockAutoSchd;
    } else {
      this.isActCashUpfront = false;
      if (this.data.accountsSet && this.data.accountsSet.length) {
        for (let i = 0; i < this.data.accountsSet.length; i++) {
          let acc = this.data.accountsSet[i];
          if (acc.actBlockAutoSchd) {
            this.isActCashUpfront = true;
            break;
          }
        }
      }
    }
    this.rebalanceTypeLists = this.gls.getRebalanceTypeListObject(this.isTlhWsaEnabled, this.isTLHSetInGlobal, ENABLE_TLH_FR, this.isActCashUpfront).map(this.mapRebalanceType);
    this.getHoliDaysList();
  }
  populateAutorebalanceData(source: any, dest: any) {
    const scheduler: IAutoSchedulerDTO = {} as IAutoSchedulerDTO;

    dest.isAutoRebalEnabled = source.isAutoRebalEnabled;
    dest.autoRebalRequestedBy = source.autoRebalRequestedBy;
    dest.autoRebalStartDate = source.autoRebalStartDate;
    dest.autoRebalNextRunDate = source.autoRebalNextRunDate;
    dest.autoRebalType = source.autoRebalType;
    if (source.investCashSetting !== undefined) {
      dest.investCashSetting = source.investCashSetting;
    }
    if (source.autoScheduler ) {
      scheduler.autoSchedulerId = source.autoScheduler.autoSchedulerId;
      scheduler.version = source.autoScheduler.version;
      scheduler.scheduleType = source.autoScheduler.scheduleType;
      scheduler.isActive = source.autoScheduler.isActive;
      scheduler.startDate = source.autoScheduler.startDate;
      scheduler.endDateType = source.autoScheduler.endDateType;
      scheduler.endByDate = source.autoScheduler.endByDate;
      scheduler.endAfterNTimes = source.autoScheduler.endAfterNTimes;
      scheduler.nextRunDate = source.autoScheduler.nextRunDate;
      scheduler.completedRunTime = source.autoScheduler.completedRunTime;
      scheduler.modifiedBy = source.autoScheduler.modifiedBy;
      scheduler.modifiedDate = source.autoScheduler.modifiedDate;
      scheduler.createdBy = source.autoScheduler.createdBy;
      scheduler.createdDate = source.autoScheduler.createdDate;
      scheduler.portfolioId = source.autoScheduler.portfolioId;
      scheduler.environmentId = source.autoScheduler.environmentId;
      scheduler.recurringFreqType = source.autoScheduler.recurringFreqType;
      scheduler.everyNDays = source.autoScheduler.everyNDays;
      scheduler.everyDay = source.autoScheduler.everyDay;
      scheduler.everyWeekday = source.autoScheduler.everyWeekday;
      scheduler.everyNMonths = source.autoScheduler.everyNMonths;
      scheduler.dateNumber = source.autoScheduler.dateNumber;
      scheduler.monthlyRecurrenceType = source.autoScheduler.monthlyRecurrenceType;
      scheduler.dayName = source.autoScheduler.dayName;
      scheduler.everyNWeeks = source.autoScheduler.everyNWeeks;
      scheduler.monday = source.autoScheduler.monday;
      scheduler.tuesday = source.autoScheduler.tuesday;
      scheduler.wednesday = source.autoScheduler.wednesday;
      scheduler.thursday = source.autoScheduler.thursday;
      scheduler.friday = source.autoScheduler.friday;
      scheduler.saturday = source.autoScheduler.saturday;
      scheduler.sunday = source.autoScheduler.sunday;
      scheduler.isDeleted = source.autoScheduler.isDeleted;
      this.endDateMinValidation=this.getTomorrow(new Date(source.autoScheduler.startDate));
      if (this.endDateMinValidation < this.afterTomorrowDate) {this.endDateMinValidation = this.afterTomorrowDate;}
    }
    dest.autoScheduler= scheduler;
  }
  setFormValues(): void {

    if (this.autoRebalanceDetails?.autoScheduler?.completedRunTime) {
      this.completedRunTime = this.autoRebalanceDetails?.autoScheduler?.completedRunTime;
    } else {
      this.completedRunTime = 0;
    }
    this.enableAutomation = this.autoRebalanceDetails.isAutoRebalEnabled ? 1: 0;
    if (this.multipleporfolios) this.enableAutomation = null;

    const autoRebalType = this.rebalanceTypeLists.find((v) => v.name === this.data.autoRebalType);
    if (autoRebalType?.name) {
      this.selectedRebalanceType.setValue(autoRebalType);
    } else {
      if (this.isActCashUpfront && this.rebalanceTypeLists.length > 1) {
        this.selectedRebalanceType.setValue(this.rebalanceTypeLists[1]);
      } else {
        this.selectedRebalanceType.setValue(this.rebalanceTypeLists[0]);
      }
    }
    if (this.autoRebalanceDetails?.autoScheduler && !this.autoRebalanceDetails.autoScheduler.endDateType) {this.autoRebalanceDetails.autoScheduler.endDateType = "No End Date";}
    if (this.autoRebalanceDetails.autoScheduler.endDateType === 'End by (date)') {
      if (this.autoRebalanceDetails?.autoScheduler?.endByDate) {
        this.schedulerEndByDate.setValue(new Date(this.autoRebalanceDetails.autoScheduler.endByDate));
      } else {
        this.schedulerEndByDate.setValue(new Date(this.afterTomorrowDate));
      }
    } else {
      this.schedulerEndByDate.setValue(null);
    }
    if (!(this.autoRebalanceDetails?.autoScheduler?.monthlyRecurrenceType) || this.autoRebalanceDetails.autoScheduler.monthlyRecurrenceType === 'a specific date') {
      this.monthlySchedulerOption = '0';
      this.selectedEveryMonthListOptions.setValue(null);
      this.selectedEveryMonthWeekDayListOptions.setValue(null);
      this.autoRebalanceDetails.autoScheduler.dayName = this.evryMonthWeekDayList[0].value;
    } else {
      const everyMonthList = this.everyMonthList.find((v) => v.value === this.autoRebalanceDetails.autoScheduler.monthlyRecurrenceType);
      this.monthlySchedulerOption = '1';
      this.autoRebalanceDetails.autoScheduler.dateNumber = null;
      if (everyMonthList) {
        this.selectedEveryMonthListOptions.setValue(everyMonthList);
      } else {
        this.selectedEveryMonthListOptions.setValue(this.everyMonthList[0]);
      }
      const everyMonthWeekDayList = this.evryMonthWeekDayList.find((v) => v.value === this.autoRebalanceDetails.autoScheduler.dayName);
      if (everyMonthWeekDayList) {
        this.selectedEveryMonthWeekDayListOptions.setValue(everyMonthWeekDayList);
      }else {
        this.selectedEveryMonthWeekDayListOptions.setValue(this.evryMonthWeekDayList[0]);
        this.autoRebalanceDetails.autoScheduler.dayName = this.evryMonthWeekDayList[0].value;
      }
    }

     if (this.autoRebalanceDetails.autoRebalStartDate) {
       const startDate = this.gls.convertYearMonthDateStringToET(this.autoRebalanceDetails.autoRebalStartDate);
      this.automationEnabledDate = new Date(startDate).toLocaleString('en-US',{timeZone: 'America/New_York', month:"2-digit",day:"2-digit", year:"numeric"});
      this.automationStartDateControl.setValue(new Date (startDate));
    }
	if (this.autoRebalanceDetails.autoScheduler.endByDate) {
	   this.automationEndDate = new Date(this.autoRebalanceDetails.autoScheduler.endByDate).toLocaleString('en-US',{timeZone: 'America/New_York', month:"2-digit",day:"2-digit", year:"numeric"});
    }
	if (this.autoRebalanceDetails.autoScheduler.startDate) {
      this.automationStartDateControl.setValue(new Date(this.autoRebalanceDetails.autoScheduler.startDate));
      this.endDateMinValidation=this.getTomorrow(new Date(this.autoRebalanceDetails.autoScheduler.startDate));
      if (this.endDateMinValidation < this.afterTomorrowDate) {this.endDateMinValidation = this.afterTomorrowDate;}
    } else {
      this.endDateMinValidation = this.afterTomorrowDate;
    }
    this.automationStartDateValidation=this.tomorrowDate;
    if (this.data.autoRebalNextRunDate) {
      this.autoRebalNextRunDate = new Date(this.data.autoRebalNextRunDate).toLocaleString('en-US',{timeZone: 'America/New_York', month:"2-digit",day:"2-digit", year:"numeric"});
    } else {
      this.autoRebalNextRunDate = '';
    }
    if (this.data.investCashSetting !== undefined) {
      this.investCashSetting = this.data.investCashSetting;
      if (this.ENABLE_INVCASH_AUTO) {
        if (this.data.autoRebalType === 'Invest cash only') {
          this.data.investCashSetting = this.investCashSetting;
        } else {
          this.data.investCashSetting = InvestCashSetting.NotApplicable;
        }
      }
    }
  }
  loadGrid() {
    this.grid.api.setGridOption('rowData', this.gridData);
    this.grid.api.refreshHeader();
  }
  load() {
    this.loadGrid();
  }
  onGridReady(params: any) {
    this.grid = params;
    this.grid.api.setGridOption('serverSideDatasource', this.setDataSource());
  }
  setDataSource() {
    return {
      getRows: (params: any) => {
        this.ies.getPfAutoRebalResultList(params, this.data.portfolioId).subscribe((response: any) => {
          if (response && response.length > 0) {
            this.gridData = response;
            this.grid.api.hideOverlay();
            if (params.request.endRow > 5) {
              this.historyGridDomLayout = 'normal';
              this.historyGridHeight = '180px';
            } else {
              this.historyGridDomLayout = 'autoHeight';
              this.historyGridHeight = '100%';
            }
          } else {
            this.grid.api.showNoRowsOverlay();
            this.historyGridDomLayout = 'normal';
            this.historyGridHeight = '180px';
          }
          this.grid = params;

          params.success({ rowData: this.gridData });

          window.setTimeout(() => {
            if (this.grid && this.grid.api)
              this.grid.api.sizeColumnsToFit();
          });
        }, () => {
          this.grid.api.showNoRowsOverlay();
          this.historyGridDomLayout = 'normal';
          this.historyGridHeight = '180px';
        });
      }};
  }
  mapRebalanceType(rebalanceType: IRebalanceTypeItem): IDropdownItem {
    return {name: rebalanceType.label, value: rebalanceType, notClickableItem: rebalanceType.notClickableItem || false, class: rebalanceType.class,
      customToolTipWhenDisabled: rebalanceType.customToolTipWhenDisabled};
  }
  setChainTypeOptionsRebalanceType(searchStr: any) {
    const f = DropdownFilterComponent.getFilteredList(searchStr, this.rebalanceTypeLists);
    if (this.selectReference) this.selectReference.set(f);
  }
  setChainTypeEveryMonthListOptions() {
    this.selecteveryMonthListReference.set(this.everyMonthList);
  }
  setChainTypeEveryMonthWeekDayListOptions() {
    this.selecteveryMonthWeekDayListReference.set(this.evryMonthWeekDayList);
  }
  showPortfolioResultDetail(params: any) {
    const self = this;
    const rebalanceID = params.rbRsltId || false;
    const portfolioId = params.portfolioId || false;
    if (rebalanceID && portfolioId) {
      const timeout = this.isUiTest ? 0 : 250;
      setTimeout(() => {
        self.as.fireEvent(IrbRebalanceEvents.SHOW_PORTFOLIO_RESULT_DETAIL, {
          fullscreen: true,
          request: {method: "getDetails", rebalId: rebalanceID, portfolioId: portfolioId, secListLoadReqd: true, doNotRemoveQueryParamsOnClose: true},
          slot: 'B'
        });
      }, timeout);
    }
  }

  //=============change events
  applyChanges() {
    if (this.autoRebalanceDetails.isAutoRebalEnabled) {
      this.data.autoRebalType = this.selectedRebalanceType?.value?.name || "";
      if (this.ENABLE_INVCASH_AUTO) {
        if (this.data.autoRebalType === 'Invest cash only') {
          this.data.investCashSetting = this.investCashSetting;
        } else {
          this.data.investCashSetting = InvestCashSetting.NotApplicable;
        }
      } else {
        delete this.data.investCashSetting;
      }
      this.autoRebalanceDetails.autoRebalRequestedBy = this.autoRebalanceDetails.autoRebalRequestedBy || this.userDetails?.userID;
      this.data.autoRebalRequestedBy = this.autoRebalanceDetails.autoRebalRequestedBy;
      if (!this.autoRebalanceDetails.autoScheduler) {this.autoRebalanceDetails.autoScheduler = {} as any;}
      if (!this.autoRebalanceDetails.autoScheduler.startDate) {
        this.autoRebalanceDetails.autoScheduler.startDate = this.gls.convertDateTimeToETforInsert(new Date(this.tomorrowDate));
      }
      if (!this.autoRebalanceDetails.autoRebalStartDate) {
        //this.autoRebalanceDetails.autoRebalStartDate = (new Date()).toISOString().replace('Z','+00:00');//this.gls.convertDateToET(new Date());
        this.autoRebalanceDetails.autoRebalStartDate = this.gls.convertDateTimeToETforInsert(new Date());
      }
      this.data.autoRebalStartDate = this.autoRebalanceDetails.autoRebalStartDate;

      this.automationEnabledDate = new Date(this.gls.convertYearMonthDateStringToET(this.autoRebalanceDetails.autoRebalStartDate)).toLocaleString('en-US', {timeZone: 'America/New_York',
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      });
      if (!this.autoRebalanceDetails.autoScheduler.recurringFreqType) {this.autoRebalanceDetails.autoScheduler.recurringFreqType = 'Daily';}
      this.automationStartDateControl.setValue(new Date(this.autoRebalanceDetails.autoScheduler.startDate));
      this.toolTipStartDate = '';
      if (!this.autoRebalanceDetails.autoScheduler.autoSchedulerId) {this.autoRebalanceDetails.autoScheduler.autoSchedulerId = null;}
      if (!this.autoRebalanceDetails.autoScheduler.version) {this.autoRebalanceDetails.autoScheduler.version = 0;}

      if (!this.autoRebalanceDetails.autoScheduler.scheduleType) {this.autoRebalanceDetails.autoScheduler.scheduleType = "Recurring";}
      if (!this.autoRebalanceDetails.autoScheduler.monthlyRecurrenceType) {this.autoRebalanceDetails.autoScheduler.monthlyRecurrenceType = null;}
      if (!this.autoRebalanceDetails.autoScheduler.endDateType) {this.autoRebalanceDetails.autoScheduler.endDateType = "No End Date";}
      if (!this.autoRebalanceDetails.autoScheduler.dayName) {this.autoRebalanceDetails.autoScheduler.dayName = null;}
      if (!this.autoRebalanceDetails.autoScheduler.endByDate) {this.autoRebalanceDetails.autoScheduler.endByDate = null;}
      if (!this.autoRebalanceDetails.autoScheduler.endAfterNTimes) {this.autoRebalanceDetails.autoScheduler.endAfterNTimes = null;}
      if (this.autoRebalanceDetails.autoScheduler.endDateType !== "End by (date)") {this.autoRebalanceDetails.autoScheduler.endByDate = null;}
      if (!this.autoRebalanceDetails.autoScheduler.isActive) {
        const d = this.gls.convertDateToET(this.tomorrowDate);
        this.autoRebalanceDetails.autoScheduler.startDate = this.gls.convertDateTimeToETforInsert(new Date(d));
        this.autoRebalanceDetails.autoScheduler.isActive = true;
        this.setEndDateAfterStartDateChanged(d);
      }
      if (this.autoRebalanceDetails.autoScheduler.startDate >= this.gls.convertDateTimeToETforInsert(new Date(this.tomorrowDate))) {
        this.autoRebalanceDetails.autoScheduler.completedRunTime = 0;
        this.completedRunTime = 0;
      }
      this.autoRebalanceDetails.autoScheduler.isActive = true;
      this.isValidNumberOfOccurrences = true;
      if (this.autoRebalanceDetails.autoScheduler.endDateType === "End after # occurrences") {
        if (this.autoRebalanceDetails.autoScheduler.endAfterNTimes < this.completedRunTime + 1 || this.autoRebalanceDetails.autoScheduler.endAfterNTimes > 1000) {
          this.isValidNumberOfOccurrences = false;
          setTimeout(() => {
            this.as.fireEvent(IrbEditorsEvents.CHANGE_OF_ISVALID, false);
          })
        }
      }
      this.data.autoScheduler = this.autoRebalanceDetails.autoScheduler;
    } else {

      this.data.autoRebalType = null;
      delete this.data.investCashSetting;
      this.data.autoRebalRequestedBy = null;
      this.data.autoRebalStartDate = null;
      if (this.data?.autoScheduler) {
        this.data.autoScheduler.dateNumber = null;
        this.data.autoScheduler.dayName = null;
        this.data.autoScheduler.endAfterNTimes = null;
        this.data.autoScheduler.endByDate = null;
        this.data.autoScheduler.endDateType = null;
        this.data.autoScheduler.everyNDays = null;
        this.data.autoScheduler.everyNMonths = null;
        this.data.autoScheduler.everyNWeeks = null;
        this.data.autoScheduler.monday = false;
        this.data.autoScheduler.tuesday = false;
        this.data.autoScheduler.wednesday = false;
        this.data.autoScheduler.thursday = false;
        this.data.autoScheduler.friday = false;
        this.data.autoScheduler.saturday = false;
        this.data.autoScheduler.sunday = false;
        this.data.autoScheduler.isActive = null;
        this.data.autoScheduler.monthlyRecurrenceType = null;
        this.data.autoScheduler.nextRunDate = null;
        this.data.autoScheduler.recurringFreqType = null;
        this.data.autoScheduler.scheduleType = null;
        this.data.autoScheduler.startDate = null;
        this.data.autoScheduler.version = null;
      }
    }
    if (this.toolTipStartDate === '' && this.toolTipEndDate === ''
     && this.isValidDateNumber && this.rebalanceFrequencyValid && this.isValidNumberOfOccurrences) {
      setTimeout(() => {
        this.as.fireEvent(IrbEditorsEvents.CHANGE_OF_ISVALID, true);
      });
    }
    this.data.isAutoRebalEdited = true;
    this.cdr.detectChanges();
    this.change.emit(true);
    this.autoRebalNextRunDate = '';
  }
  mouseHover(event: boolean) {
    this.showDisabledTextMessage = false;
    this.showDisabledTextMessageWhenAutoRebEnabled = false;
    if (!this.isUserAutoRebalanceEnabled) {
      this.automatedRebalanceDisabledMessage = this.userReadOnlyDisabledMessage;
      this.showDisabledTextMessage = event;
    } else if (this.multipleporfolios && this.isMultiPortfolioAllowedLimitExceeded) {
      this.automatedRebalanceDisabledMessage = this.multiPortfolioAllowedLimitMessage;
      this.showDisabledTextMessage = event;
    }

  }
  onAutoRebalanceEnabledChange(event: any) {
    const enabled = event?.checked;
    if (enabled) {
      this.onChangeAutoEnable();
    } else {
      this.onChangeAutoDisable();
    }
  }
  onChangeAutoEnable() {
    this.autoRebalanceDetails = JSON.parse(JSON.stringify(this.originalDataFromServer));
    this.data.isAutoRebalEnabled = true;
    this.autoRebalanceDetails.isAutoRebalEnabled = true;
    this.autoRebalanceDetails.autoRebalRequestedBy = this.userDetails?.userID;
    this.enableAutomation = 1;
    this.applyChanges();
  }
  onChangeAutoDisable() {
    this.data.isAutoRebalEnabled = false;
    this.autoRebalanceDetails.isAutoRebalEnabled = false;
    this.enableAutomation = 0;
    this.applyChanges();
  }
  onChangePattern() {
    this.autoRebalanceDetails.autoScheduler.everyNDays = null;
    this.autoRebalanceDetails.autoScheduler.everyNWeeks = null;
    this.autoRebalanceDetails.autoScheduler.everyNMonths = null;
    if (this.autoRebalanceDetails.autoScheduler.recurringFreqType === 'Daily' && !this.autoRebalanceDetails.autoScheduler.everyNDays) {this.autoRebalanceDetails.autoScheduler.everyNDays = 1;}
    if (this.autoRebalanceDetails.autoScheduler.recurringFreqType === 'Weekly' && !this.autoRebalanceDetails.autoScheduler.everyNWeeks) {this.autoRebalanceDetails.autoScheduler.everyNWeeks = 1;}
    if (this.autoRebalanceDetails.autoScheduler.recurringFreqType === 'Monthly' && !this.autoRebalanceDetails.autoScheduler.everyNMonths) {this.autoRebalanceDetails.autoScheduler.everyNMonths = 1;}
    if (this.autoRebalanceDetails.autoScheduler.recurringFreqType === 'Monthly' && !this.autoRebalanceDetails.autoScheduler.dateNumber) {this.autoRebalanceDetails.autoScheduler.dateNumber = 1}
    if (this.autoRebalanceDetails.autoScheduler.recurringFreqType === 'Monthly' && !this.autoRebalanceDetails.autoScheduler.monthlyRecurrenceType) {this.autoRebalanceDetails.autoScheduler.monthlyRecurrenceType = 'a specific date'}
    this.applyChanges();
  }
  onWeekDayChange() {
    this.applyChanges();
  }
  onMonthlySchedulerSwitch() {
    if (this.monthlySchedulerOption === '0') {
      this.monthSelection(this.specificDayObj);
    } else {
      this.monthSelection(this.selectedEveryMonthListOptions.value);
    }
  }
  automationStartDateChange(event: any) {
    let dateChange = event?.value;
    this.toolTipStartDate = '';
    if (!dateChange
      || (dateChange && !this.myFilter(dateChange))
      || ((new Date(this.gls.convertDateToET(dateChange))).getTime() < (new Date(this.gls.convertDateToET(this.automationStartDateValidation))).getTime())
    ) {
      this.toolTipStartDate = 'This value is out of range';
      setTimeout(() => {
        this.as.fireEvent(IrbEditorsEvents.CHANGE_OF_ISVALID, false);
      })
      return;
    }
    const d = this.gls.convertDateToET(dateChange);
    this.autoRebalanceDetails.autoScheduler.startDate = this.gls.convertDateTimeToETforInsert(new Date(d));
    this.setEndDateAfterStartDateChanged(d);
    if (this.autoRebalanceDetails.autoScheduler.endDateType !== "End by (date)") {
      this.applyChanges();
    }
  }
  setEndDateAfterStartDateChanged(d: string) {
    this.endDateMinValidation=this.getTomorrow(new Date(d));
    if (this.autoRebalanceDetails.autoScheduler.endDateType !== "End by (date)") {
      this.autoRebalanceDetails.autoScheduler.endByDate = null;
      return;
    }
    if (!this.autoRebalanceDetails.autoScheduler.endByDate || this.autoRebalanceDetails.autoScheduler.endByDate <= this.autoRebalanceDetails.autoScheduler.startDate) {
      this.autoRebalanceDetails.autoScheduler.endByDate = this.gls.convertDateTimeToETforInsert(this.getTomorrow(new Date(d)));
      this.schedulerEndByDate.setValue(new Date(this.autoRebalanceDetails.autoScheduler.endByDate));
      this.toolTipEndDate = '';
    }
    this.applyChanges();
  }
  selectRebalanceType(event: any) {
    this.selectedRebalanceType.setValue(event);
    this.data.autoRebalType = event.name;
    if (this.ENABLE_INVCASH_AUTO && this.data.autoRebalType === 'Invest cash only') {
      const setting = this.data?.investCashSetting;
      this.investCashSetting = (setting && setting !== InvestCashSetting.NotApplicable) ? setting : InvestCashSetting.Securities;
    }
    this.applyChanges();
  }

  onEveryDayList(event: any) {
    this.selectedEveryMonthWeekDayListOptions.setValue(event);
    this.autoRebalanceDetails.autoScheduler.dayName = event.value;
    this.applyChanges();
  }
  rebalanceFrequencyChange(event:any, recurringFreqType: string) {
    this.rebalanceFrequencyValid = true;
    let isChanged = false;
    if (event) {
      if (recurringFreqType === 'Daily') {
        this.autoRebalanceDetails.autoScheduler.everyNWeeks = null;
        this.autoRebalanceDetails.autoScheduler.everyNMonths = null;
        if (this.autoRebalanceDetails.autoScheduler.everyNDays !== event) {
          this.autoRebalanceDetails.autoScheduler.everyNDays = event;
          isChanged = true;
          if (event && (event < 1 || event > 365)) {
            this.rebalanceFrequencyValid = false;
          }
        }
      } else if (recurringFreqType === 'Weekly') {
        this.autoRebalanceDetails.autoScheduler.everyNDays = null;
        this.autoRebalanceDetails.autoScheduler.everyNMonths = null;
        if (this.autoRebalanceDetails.autoScheduler.everyNWeeks !== event) {
          this.autoRebalanceDetails.autoScheduler.everyNWeeks = event;
          isChanged = true;
          if (event && (event < 1 || event > 52)) {
            this.rebalanceFrequencyValid = false;
          }
        }
      } else if (recurringFreqType === 'Monthly') {
        this.autoRebalanceDetails.autoScheduler.everyNWeeks = null;
        this.autoRebalanceDetails.autoScheduler.everyNDays = null;
        if (this.autoRebalanceDetails.autoScheduler.everyNMonths !== event) {
          this.autoRebalanceDetails.autoScheduler.everyNMonths = event;
          isChanged = true;
          if (event && (event < 1 || event > 12)) {
            this.rebalanceFrequencyValid = false;
          }
        }
      }
      if (!this.rebalanceFrequencyValid ) {
        setTimeout(() => {
          this.as.fireEvent(IrbEditorsEvents.CHANGE_OF_ISVALID, false);
        })
        return;
      }
      if (isChanged) {
        this.applyChanges();
      }
    }
  }
  onEndOptionSwitch() {
    if (this.autoRebalanceDetails.autoScheduler.endDateType === 'End after # occurrences') {
      if (!this.autoRebalanceDetails.autoScheduler.endAfterNTimes
      || this.autoRebalanceDetails.autoScheduler.endAfterNTimes < this.completedRunTime + 1
      || this.autoRebalanceDetails.autoScheduler.endAfterNTimes > 1000
       ) {
        this.endAfterNTimesReady = false;
        this.autoRebalanceDetails.autoScheduler.endAfterNTimes = this.completedRunTime + 1;
        this.schedulerEndByDate.setValue(null);
        setTimeout(() => {this.endAfterNTimesReady = true;}, 20);
      }
      this.applyChanges();
    } else if (this.autoRebalanceDetails.autoScheduler.endDateType === 'End by (date)') {
      if (this.autoRebalanceDetails?.autoScheduler?.endByDate && this.autoRebalanceDetails?.autoScheduler?.endByDate >= this.endDateMinValidation) {
        this.schedulerEndByDate.setValue(this.autoRebalanceDetails.autoScheduler.endByDate);
      } else {
        this.schedulerEndByDate.setValue(this.endDateMinValidation);
      }
      this.autoRebalanceDetails.autoScheduler.endAfterNTimes = null;
      this.endDateChange(this.schedulerEndByDate);
    } else {
      this.autoRebalanceDetails.autoScheduler.endAfterNTimes = null;
      this.autoRebalanceDetails.autoScheduler.endDateType = "No End Date";
      this.schedulerEndByDate.setValue(null);
      this.applyChanges();
    }
  }
  monthSelection(event: any) {
    if (!event) {
      event = this.everyMonthList[0];
    }
    this.autoRebalanceDetails.autoScheduler.monthlyRecurrenceType = event.value;
    if (event?.value === 'a specific date') {
      this.autoRebalanceDetails.autoScheduler.dateNumber = 1;
      this.selectedEveryMonthWeekDayListOptions.setValue(null);
      this.selectedEveryMonthListOptions.setValue(null);
      this.autoRebalanceDetails.autoScheduler.dayName = this.evryMonthWeekDayList[0].value;
    } else {
      this.autoRebalanceDetails.autoScheduler.dateNumber = null;
      this.selectedEveryMonthListOptions.setValue(event);
      const everyMonthWeekDayList = this.evryMonthWeekDayList.find((v) => v.value === this.autoRebalanceDetails.autoScheduler.dayName);
      if (everyMonthWeekDayList) {
        this.autoRebalanceDetails.autoScheduler.dayName = everyMonthWeekDayList.value;
        this.selectedEveryMonthWeekDayListOptions.setValue(everyMonthWeekDayList);
      }else {
        this.autoRebalanceDetails.autoScheduler.dayName = this.evryMonthWeekDayList[0].value;
        this.selectedEveryMonthWeekDayListOptions.setValue(this.evryMonthWeekDayList[0]);
      }

    }
    this.applyChanges();
  }
  endDateChange(event: any) {
    let endDateChange = event?.value;
    this.toolTipEndDate = '';
    if (!endDateChange
      || (endDateChange && !this.myFilter(endDateChange))
      || ((new Date(this.gls.convertDateToET(endDateChange))).getTime() < (new Date(this.gls.convertDateToET(this.endDateMinValidation))).getTime())
    ) {
      this.toolTipEndDate = 'This value is out of range';
      setTimeout(() => {
        this.as.fireEvent(IrbEditorsEvents.CHANGE_OF_ISVALID, false);
      })
      return;
    }
    const dCreated = this.gls.convertDateToET(endDateChange);

    this.autoRebalanceDetails.autoScheduler.endByDate = this.gls.convertDateTimeToETforInsert(new Date(dCreated));
    this.applyChanges();
  }
  endAfterNTimesChange(event: any) {
    if (event && this.autoRebalanceDetails.autoScheduler.endAfterNTimes !== event) {
      this.autoRebalanceDetails.autoScheduler.endAfterNTimes = event;
      this.applyChanges();
    }
  }
  dateNumberChange(event: any) {
    this.isValidDateNumber = true;
    if (event && this.autoRebalanceDetails.autoScheduler.dateNumber !== event) {
      this.autoRebalanceDetails.autoScheduler.dateNumber = event;
      if (event && (event <1 || event > 31)) {
        this.isValidDateNumber = false;
        setTimeout(() => {
          this.as.fireEvent(IrbEditorsEvents.CHANGE_OF_ISVALID, false);
        })
      }
      this.applyChanges();
    }
  }
  showHistory() {
    this.isShowHistory = true;
    this.as.setToSession("ShowAutoRebalanceHistory", this.isShowHistory);
  }
  hideHistory() {
    this.isShowHistory = false;
    this.as.setToSession("ShowAutoRebalanceHistory", this.isShowHistory);
  }
  getRowCount() {
    return 0;
  }
  myFilter = (d: Date): boolean => {
    if (!d) {
      return false;
    }
    const day = d.getDay();
    const timeOfDay: number = d.getTime();
    const passCondition = (element: any) => (timeOfDay >= element && timeOfDay <  element + 24*3600*1000);
    let isHoliday = false;
    if (this.holidayDateList && this.holidayDateList.length !== 0) {
      isHoliday = this.holidayDateList.some(passCondition);
    }

    return day !== 0 && day !== 6 && !isHoliday;
  };

  getTomorrow(dateStart = new Date()) {
    //const d = new Date(this.formatEasternDate(new Date(), "/") + ' 00:00:00 GMT-0400');
    //const d = new Date(dateToSet.toLocaleString('en-US', {timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric'}));
    dateStart = this.us.incrementDays(dateStart, 1);
    while (!this.myFilter(dateStart)) {
      dateStart = this.us.incrementDays(dateStart, 1);
    }
    return new Date(this.gls.convertDateToET(dateStart));
  }
  getHoliDaysList() {
    this.holidayDateList = [];
    if (this.isUiTest) this.tomorrowDate=this.getTomorrow();
    this.crbservice.getVeoNonProcessingDays().subscribe((holidays: any) => {
      holidays.forEach((hd: string) => {
        if (hd) {
          this.holidayDateList.push(new Date(hd).getTime() - 24*3600*1000); //subtracting 1 day to get M-F (not Tue-Sa) holiday list
        }
      });
      this.tomorrowDate=this.getTomorrow();
      this.afterTomorrowDate=this.getTomorrow(this.tomorrowDate);
      this.populateAutorebalanceData(this.data, this.autoRebalanceDetails);
      this.setFormValues();
    });
  }
  validateDateNumberInput() {
    const i = this.autoRebalanceDetails.autoScheduler.dateNumber;
    this.endOfMonthWarning = i >= 29 && i <= 31 ? "Some months have fewer than 31 days. For these months, the occurrence will fall on the last business day of the month" : "";
  }

  onInvestCashChange() {
    this.data.investCashSetting = this.investCashSetting;
    this.applyChanges();
  }

  viewPortfolioModel() {
    let data: any =  {};
    data.slot ="B";
    data.isDraft = false;

    if(this.selectedModel && this.selectedModel.modelType ==="Blended") {
      let modelId = this.selectedModel.securityModelId.replace('b','').replace('B','');
      data.blendedSecurityModelId = modelId;
      data.modelId = modelId;
      data.type = this.selectedModel.modelType;
    } else {
      data.modelId = this.selectedModel.securityModelId;
      data.type = "Base";
    }
    this.as.fireEvent(IrbModelsEvents.SHOW_EDIT_MODEL, data);
  }
protected readonly faChevronRight = faChevronRight;
protected readonly InvestCashSetting = InvestCashSetting; }
